<div *ngFor="let shopSession of shopSessions; trackBy: trackByFn" class="shop-session-container" >
    <div class="shop-session">
        <div class="session-details-section" >
            <div class="table-container">
                <div class="shopSession-details">
                    <h4>Shop Session Table</h4>
                    <table class="shopSession-details-table">
                        <tbody>
                        <tr>
                            <th>Shop Session ID</th>
                            <td>{{shopSession.shopSessionId }}</td>
                        </tr>
                        <tr>
                            <th>Short URL ID</th>
                            <td>{{shopSession.shortUrlId}} (www.usana.com/s/{{ shopSession.shortUrlId }})</td>
                        </tr>
                        <tr>
                            <th>Referer</th>
                            <td>{{ shopSession.referer }}</td>
                        </tr>
                        <tr>
                            <th>IP Address</th>
                            <td>HIDDEN</td>
                        </tr>
                        <tr>
                            <th>User Agent</th>
                            <td>{{ shopSession.userAgent }}</td>
                        </tr>
                        <tr>
                            <th>Create Date</th>
                            <td>{{ shopSession.createDate }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <h4>Short Url Table</h4>
                    <table class="shopSession-details-table">
                        <tbody>
                        <tr>
                            <th>Short URL ID</th>
                            <td>{{shopSession.shortUrlId}}</td>
                        </tr>
                        <tr>
                            <th>Long URL</th>
                            <td>{{ shopSession.longUrl }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="shopSession.shareable" class="shareable-section">
                    <h4>Shareable Table</h4>
                    <table class="shareable-table">
                        <tbody>
                        <tr>
                            <th>Shareable ID</th>
                            <td>{{ shopSession.shareable.shareableId }}</td>
                        </tr>
                        <tr>
                            <th>Short URL ID</th>
                            <td>{{ shopSession.shareable.shortUrlId }}</td>
                        </tr>
                        <tr>
                            <th>Target Platform</th>
                            <td>{{ shopSession.shareable.targetPlatform }}</td>
                        </tr>
                        <tr>
                            <th>Share Type</th>
                            <td>{{ shopSession.shareable.shareType }}</td>
                        </tr>
                        <tr>
                            <th>Share ID</th>
                            <td>{{ shopSession.shareable.shareId }}</td>
                        </tr>
                        <tr>
                            <th>Sponsor ID</th>
                            <td>{{ shopSession.shareable.sponsorId }}</td>
                        </tr>
                        <tr>
                            <th>Sponsor Customer Type</th>
                            <td>{{ shopSession.shareable.sponsorCustomerType }}</td>
                        </tr>
                        <tr>
                            <th>Sponsor Country Code</th>
                            <td>{{ shopSession.shareable.sponsorCountry }}</td>
                        </tr>
                        <tr>
                            <th>Sponsor Language Code</th>
                            <td>{{ shopSession.shareable.sponsorLanguage }}</td>
                        </tr>
                        <tr>
                            <th>Shopper Source</th>
                            <td>{{ shopSession.shareable.shopperSource }}</td>
                        </tr>
                        <tr>
                            <th>Share From</th>
                            <td>{{ shopSession.shareable.shareFrom }}</td>
                        </tr>
                        <tr>
                            <th>Placement ID</th>
                            <td>{{ shopSession.shareable.sharePlacementId }}</td>
                        </tr>
                        <tr>
                            <th>Placement Side</th>
                            <td>{{ shopSession.shareable.sharePlacementSide }}</td>
                        </tr>
                        <tr>
                            <th>Placement BC</th>
                            <td>{{ shopSession.shareable.sharePlacementBc }}</td>
                        </tr>
                        <tr>
                            <th>Create Date</th>
                            <td>{{ shopSession.shareable.createDate }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div *ngIf="shopSession.shopSessionEvents && shopSession.shopSessionEvents.length" class="events-section">
                <h4>Shop Session Event Table</h4>
                <table class="event-table">
                    <thead>
                    <tr>
                        <th>Shop Session Event ID</th>
                        <th>Sponsor ID</th>
                        <th>Retail ID</th>
                        <th>Customer ID</th>
                        <th>Order ID</th>
                        <th>Event Category</th>
                        <th>Event Type</th>
                        <th>Event Data 1</th>
                        <th>Event Data 2</th>
                        <th>Create Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let event of shopSession.shopSessionEvents; trackBy: trackByFn" [ngClass]="event.isNew? 'new-event-item': 'event-item'">
                        <td>{{ event.shopSessionEventId }}</td>
                        <td>{{ event.sponsorId }}</td>
                        <td>{{ event.retailId }}</td>
                        <td>{{ event.customerId}}</td>
                        <td>{{ event.orderId}}</td>
                        <td>{{ event.eventCategory }}</td>
                        <td>{{ event.eventType }}</td>
                        <td>{{ event.eventData1}}</td>
                        <td>{{ event.eventData2}}</td>
                        <td>{{ event.createDate }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
